import { useEffect, useState } from "react";
import { getDeceasedInfos } from "../../../api/pro/deceasedReq";
import { useLocation, useParams } from "react-router-dom";
import useDeceased from "../../../hooks/useDeceased";
import useAuth from "../../../hooks/useAuth";
import FormOtherDeceasedInfos from "../../../forms/deceased/FormOtherDeceasedInfos";
import { safeJwtDecode } from "../../../helper/jwtHelper";
import useData from "../../../hooks/useData";
import { getAgencySiteInfos } from "../../../api/admin/agencyReq";
import Icon from "../../../components/common/Icon";

export default function ViewDeceasedOtherInfos() {
    const { auth } = useAuth();
    const token = auth?.token;
    const { deceasedInfos, setDeceasedInfos, newForm } = useDeceased();
    const { agencySite, setAgencySite } = useData();
    const { id } = useParams();
    const IMG_FOLDER = process.env.REACT_APP_LOCAL_ASSETS_BASE_URL;
    const decodedToken = safeJwtDecode(token);
    const agencyId = decodedToken?.agency;
    const [showModalPortrait, setShowModalPortrait] = useState(false);
    const [showModalPublication, setShowModalPublication] = useState(false);
    const { pathname } = useLocation();

    const currentData = pathname?.includes("nouveau") ? newForm : deceasedInfos;

    const apiDeceasedInfos = async () => {
        const response = await getDeceasedInfos(token, id)
        setDeceasedInfos(response)
    }

    const apiAgencySite = async () => {
        const response = await getAgencySiteInfos(token, agencyId)
        setAgencySite(response)
    }


    useEffect(() => {
        {
            pathname.includes("infos-defunt") &&
                apiDeceasedInfos()
        }
    }, [id]);

    useEffect(() => {
        apiAgencySite()
    }, [agencyId]);

    const handleFormPortrait = () => {
        setShowModalPortrait(true)
    }

    const handleFormPublication = () => {
        setShowModalPublication(true)
    }

    return (
        <>
            {showModalPortrait &&
                <div className="modal deceased-other">
                    <div className="form-infos">
                        <FormOtherDeceasedInfos
                            apiAgencyProInfos={apiAgencySite}
                            setShowModal={setShowModalPortrait}
                            deceased={pathname.includes("infos-defunt") || pathname?.includes("nouveau") ? deceasedInfos : ""}
                            modalType="portrait"
                        />
                    </div>
                </div>
            }
            {showModalPublication &&
                <div className="modal deceased-other">
                    <div className="form-infos">
                        <FormOtherDeceasedInfos
                            apiAgencyProInfos={apiAgencySite}
                            setShowModal={setShowModalPublication}
                            deceased={pathname.includes("infos-defunt") || pathname?.includes("nouveau") ? deceasedInfos : ""}
                            modalType="publication"
                        />
                    </div>
                </div>
            }
            <form className="admin-form">
                {/* Fieldset Portrait */}
                <fieldset className="margin-fieldset view-mode">
                    <Icon
                        span={pathname.includes("defunt") || pathname?.includes("nouveau") ? `Portrait du défunt` : `Logo de l'agence`}
                        source="fa fa-image"/>
                    <div className="form-input">
                        <div className={pathname.includes("defunt") || pathname?.includes("nouveau") ? `avatar` : "logo-agence"}>
                            <img
                                src={pathname.includes("infos-defunt") ?
                                    (currentData?.useGalleryPortrait && currentData?.portrait) ?
                                        `${IMG_FOLDER}/img/deceased_library/${agencyId}/${currentData?.portrait}`
                                        : (!currentData?.useGalleryPortrait && currentData?.portrait) ? `${IMG_FOLDER}/img/${currentData?.uploadDir}/${currentData?.portrait}`
                                            : `${IMG_FOLDER}/img/deceased_library/${currentData?.portrait}`
                                    : pathname?.includes("nouveau") ?
                                        currentData?.image ? currentData?.image  // Image base64 ou URL complète
                                            : currentData?.url ? `${IMG_FOLDER}/img/deceased_library/${agencyId}/${currentData?.url}` // Image de bibliothèque (essayer agence d'abord)
                                                : currentData?.portrait ? `${IMG_FOLDER}/img/deceased_library/${currentData?.portrait}` // Portrait par défaut
                                                    : `${IMG_FOLDER}/img/deceased_library/default.jpg` // Image par défaut
                                        : `${IMG_FOLDER}/media/logos/${agencySite?.logo}`
                                }
                                alt={(pathname.includes("defunt") || pathname?.includes("nouveau")) ? "portrait du défunt" : "logo de l'agence"}
                                onError={(e) => {
                                    if ((currentData?.useGalleryPortrait || currentData?.url) && e.target.src.includes(`/${agencyId}/`)) {
                                        // Si l'image n'existe pas dans le dossier agence, essayer la racine
                                        e.target.onerror = null;
                                        const filename = currentData?.portrait || currentData?.url;
                                        e.target.src = `${IMG_FOLDER}/img/deceased_library/${filename}`;
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="buttons-container">
                        <button type="button" className="red-button" onClick={handleFormPortrait}><i className="fa fa-pen-to-square"/><span>Modifier les informations</span></button>
                    </div>
                </fieldset>

                {/* Fieldset Publication - uniquement pour les défunts */}
                {(pathname.includes("infos-defunt") || pathname?.includes("nouveau")) &&
                    <fieldset className="margin-fieldset view-mode">
                        <legend>
                            Publication sur Internet
                            <i className="fa fa-pen-to-square" onClick={handleFormPublication}></i>
                        </legend>
                        <div className="form-input">
                            <label>Autoriser la publication de la page du défunt sur Internet ?</label>
                            <span>{(currentData?.isListed === 1 || currentData?.isListed === "1" || currentData?.isListed === true) ? "Oui" : "Non"}</span>
                        </div>
                        <div className="buttons-container">
                            <button type="button" className="red-button" onClick={handleFormPublication}><i className="fa fa-pen-to-square"/><span>Modifier les informations</span></button>
                        </div>
                    </fieldset>
                }
            </form>
        </>
    )
}
